export const validatePhone = (phone: string) => {
    return phone.length > 4 && isNumeric(phone);
}

export const isNumeric = (str: string) => {
    if (typeof str != "string") return false // we only process strings!  
    return !isNaN(parseInt(str)) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}